import React from 'react';
import {Nav, Navbar} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import '../../App.scss';

function NavBar() {
    return (
        <Navbar fixed="top" collapseOnSelect expand="lg" bg="dark" variant="dark">
            <Navbar.Brand href="#home">
                <img
                    style={{ borderRadius: '50%', border: '3px solid #000'}}
                    alt=""
                    src="/img/Corona.png"
                    width="30"
                    height="30"
                    className="d-inline-block align-top"
                /><span style={{marginLeft: '10px'}}>Coronavirus Trivia Game</span>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav"/>
            <Navbar.Collapse id="responsive-navbar-nav">
                <Nav className="mr-auto">
                    <Link to="/" className="nav-link">Home</Link>
                    <Link to="/subscribe" className="nav-link">Subscribe</Link>
                </Nav>
            </Navbar.Collapse>
        </Navbar>
    );
}

export default NavBar;
